import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService } from 'kea-resource';

const controller = rpcController("ChoferEAD");
const crud = rpcCrudService<models.ChoferEAD, models.ChoferEADDto>(controller);

export const ChoferEAD = cacheResource({
    ...crud,

    /**Deshabilita el chofer de ead */
    Deshabilitar: async (id: number): Promise<void> => await controller('Deshabilitar', { id }),

    /**Habilitar el chofer de ead */
    Habilitar: async (id: number): Promise<void> => await controller('Habilitar', { id }),

    QueryByIdSucursal: async (idSucursal:number): Promise<models.ChoferEADDto[]> => await controller("QueryByIdSucursal",{ idSucursal }),

    QueryCamionByIdSucursal: async (idSucursal:number): Promise<models.CamionEADDto[]> => await controller("QueryCamionByIdSucursal",{ idSucursal }),

}, {
    }, {
        Deshabilitar: true,
        Habilitar: true,
        
    });




// WEBPACK FOOTER //
// ./app/resources/items/choferead.tsx